export const meta = {
  id: 'odd-even-sort',
  name: 'Odd-Even Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²)',
    space: 'O(1)'
  },
  description: 'Odd-Even Sort (Brick Sort) is a parallel variant of Bubble Sort that alternates between comparing odd-indexed and even-indexed adjacent pairs.'
};
